export * from './attribute-string-parser';
